<template>
  <a-modal :centered="true" v-model="showModal" :footer="null" @cancel="hide" width="587px" class="mobile-modal-fullscreen" :closable="false">
    <div class="d-flex align-items-center mb-4">
      <font-awesome-icon :icon="['fal', 'times']" class="show-in-mobile font-black mr-3 font20" @click="hide" />
      <h4 class="fw700 font24 gray700 mb-0 text-capitalize">Previous {{ currentName }}</h4>
      <font-awesome-icon :icon="['fal', 'times']" class="hide-in-mobile font-black ml-auto cp font20" @click="hide" />
    </div>
    <div class="eachBox d-flex cp p-4" @click="handleModal(currentName, 'add')">
      <font-awesome-icon :icon="['far', 'plus']" class="m-auto" :style="{ color: getPrimaryColor() }" />
    </div>
    <div class="eachBox" v-for="medication in medicationsToToggle" :key="medication.id">
      <div class="d-flex align-items-center">
        <div :class="`dot bg-${getEffectColor(medication.effectiveness)}`"></div>
        <p class="ml-1 mb-0 font16 fw700 newColor flex-grow-1">
          {{ medication.treatment ? medication.treatment[0].display_name : medication.nonmedication.display_name }}
        </p>
        <font-awesome-icon :icon="['fas', 'pen']" class="mr-4 cp" :style="{ color: getPrimary300Color() }" @click="handleModal(currentName, 'edit', medication)" />
        <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300" @click="handleDelete(medication)" />
      </div>
      <div class="d-flex align-items-center mt-3" v-if="!['nutritions', 'activities'].includes(currentName)">
        <p class="mb-0 mr-2 font12 gray900" style="min-width: 70px">Side Effects:</p>
        <div class="d-flex align-items-center flex-wrap gap8" v-if="medication.side_effect && medication.side_effect.length">
          <div class="eachSideEffect d-flex" v-for="sideEffect in medication.side_effect" :key="sideEffect">
            <p class="mr-3 mb-0 gray900 font12">{{ sideEffect.display_name }}</p>
            <p :class="`${getSideEffectColor(sideEffect.effectiveness)} mb-0 fw700 font12`">{{ getSideEffectLevel(sideEffect.effectiveness) }}</p>
          </div>
        </div>
        <template v-else> <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1">None</div> </template>
      </div>
      <div class="d-flex align-items-center mt-3">
        <p class="mb-0 font12 gray900">
          Effectiveness:
          <span :class="`${getEffectColor(medication.effectiveness)} fw700 font12 ml-3`">
            {{ getEffectLevel(medication.effectiveness) }}
          </span>
        </p>
      </div>
      <div class="d-flex align-items-center mt-3">
        <p class="mb-0 font12 gray900">
          Using since: {{ isDateToday(new Date(medication.treatment_duration[0][0])) ? "Today" : new Date(medication.treatment_duration[0][0]).toDateString().substring(4) }}
        </p>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "ViewDetailsModal",
  props: { handleModal: Function, handleDeleteMed: Function },
  data() {
    return { currentName: "", currentNameId: "", showModal: false, medicationsToToggle: [] }
  },
  methods: {
    show(name, oldVal, id = "") {
      this.currentName = name
      this.currentNameId = id
      this.showModal = true
      this.medicationsToToggle = oldVal
    },
    hide() {
      this.showModal = false
    },
    handleDelete(val) {
      UserRepository.removeTreatment(val.id)
        .then(r => {
          this.medicationsToToggle = this.medicationsToToggle.filter(m => m.id !== val.id)
          this.$notification.success({ message: "Deleted", description: `${this.currentNameId.charAt(0).toUpperCase() + this.currentNameId.slice(1)} has been deleted successfully` })
          UserRepository.updateDovedaily(this.currentCircle.id, { updated_at: new Date() })
          this.handleDeleteMed(this.currentName, val.id)
        })
        .catch(e => {})
    },
    getSideEffectColor(e) {
      switch (e) {
        case 0:
        case "0":
          return "success500"
        case 50:
        case "50":
          return "warning500"
        case 100:
        case "100":
          return "error500"
      }
    },
    getEffectColor(e) {
      switch (e) {
        case null:
          return "gray400"
        case 0:
        case "0":
          return "error500"
        case 50:
        case "50":
          return "warning500"
        case 100:
        case "100":
          return "success500"
      }
    },
    getEffectLevel(e) {
      switch (e) {
        case null:
          return "Not specified"
        case 0:
        case "0":
          return "Not effective"
        case 50:
        case "50":
          return "Somewhat effective"
        case 100:
        case "100":
          return "Very effective"
      }
    },
    getSideEffectLevel(e) {
      switch (e) {
        case 0:
        case "0":
          return "Mild"
        case 50:
        case "50":
          return "Moderate"
        case 100:
        case "100":
          return "Severe"
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.eachBox {
  border: 1px solid #e2e8f0;
  padding: 12px;
}
.dot {
  width: 7px;
  height: 7px;
  border-radius: 2px;
  transform: translateY(1px);
}
.eachSideEffect {
  padding: 4px 8px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.newColor {
  color: #585757;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/dovedaily/ViewDetails.vue